<!-- TOMAR FOTOGRAFÍA -->
<app-sales-credit-number [creditNumber]="data().number" [data]="data()" *ngIf="categoryCode !== 'kredicash' "></app-sales-credit-number>
<ng-container *ngIf="step === Step.camera">
  <div class="container section__photography h-full" *ngFor="let groupedField of groupedFields">
    <div class="wrapper" *ngFor="let field of groupedField.fields">
      <div class="sectionContainer fadeinright animation-duration-200">
        <article>
          <app-sales-breadcrumbs [routes]="routesBreadcrumbs"/>
          <div class="mainInfo">
            <h1>{{groupedField.title}}</h1>
            <p>{{ field.label }}</p>
          </div>

          <div #webcamContainer class="webcam mt-30">
            <div class="loading-indicator">
              <p-progressSpinner></p-progressSpinner>
            </div>

            <webcam
              [trigger]="triggerObservable"
              [videoOptions]="videoOptions"
              [allowCameraSwitch]="true"
              [mirrorImage]="'never'"
              [imageType]="'image/png'"
              [imageQuality]="0.92"
              (imageCapture)="handleImage($event)"
              (initError)="handleInitError($event)"
              (cameraSwitched)="switchCamera($event)">
            </webcam>

            <div class="webcam__region">
              <div class="limits">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.5 -6.55671e-08C23.3284 -2.93554e-08 24 0.671573 24 1.5C24 2.32843 23.3284 3 22.5 3L1.5 3C0.671574 3 -1.01779e-07 2.32843 -6.55671e-08 1.5C-2.93554e-08 0.671572 0.671574 -1.01972e-06 1.5 -9.83506e-07L22.5 -6.55671e-08Z" fill="white"/>
                  <path d="M-6.55671e-08 1.5C-2.93554e-08 0.671572 0.671574 -1.01972e-06 1.5 -9.83506e-07C2.32843 -9.83506e-07 3 0.671572 3 1.5L3 22.5C3 23.3284 2.32843 24 1.5 24C0.671573 24 8.87631e-07 23.3284 9.23842e-07 22.5L-6.55671e-08 1.5Z" fill="white"/>
                </svg>
              </div>
              <div class="limits">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.5 -6.55671e-08C23.3284 -2.93554e-08 24 0.671573 24 1.5C24 2.32843 23.3284 3 22.5 3L1.5 3C0.671574 3 -1.01779e-07 2.32843 -6.55671e-08 1.5C-2.93554e-08 0.671572 0.671574 -1.01972e-06 1.5 -9.83506e-07L22.5 -6.55671e-08Z" fill="white"/>
                  <path d="M-6.55671e-08 1.5C-2.93554e-08 0.671572 0.671574 -1.01972e-06 1.5 -9.83506e-07C2.32843 -9.83506e-07 3 0.671572 3 1.5L3 22.5C3 23.3284 2.32843 24 1.5 24C0.671573 24 8.87631e-07 23.3284 9.23842e-07 22.5L-6.55671e-08 1.5Z" fill="white"/>
                </svg>
              </div>
              <div class="limits">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.5 -6.55671e-08C23.3284 -2.93554e-08 24 0.671573 24 1.5C24 2.32843 23.3284 3 22.5 3L1.5 3C0.671574 3 -1.01779e-07 2.32843 -6.55671e-08 1.5C-2.93554e-08 0.671572 0.671574 -1.01972e-06 1.5 -9.83506e-07L22.5 -6.55671e-08Z" fill="white"/>
                  <path d="M-6.55671e-08 1.5C-2.93554e-08 0.671572 0.671574 -1.01972e-06 1.5 -9.83506e-07C2.32843 -9.83506e-07 3 0.671572 3 1.5L3 22.5C3 23.3284 2.32843 24 1.5 24C0.671573 24 8.87631e-07 23.3284 9.23842e-07 22.5L-6.55671e-08 1.5Z" fill="white"/>
                </svg>
              </div>
              <div class="limits">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.5 -6.55671e-08C23.3284 -2.93554e-08 24 0.671573 24 1.5C24 2.32843 23.3284 3 22.5 3L1.5 3C0.671574 3 -1.01779e-07 2.32843 -6.55671e-08 1.5C-2.93554e-08 0.671572 0.671574 -1.01972e-06 1.5 -9.83506e-07L22.5 -6.55671e-08Z" fill="white"/>
                  <path d="M-6.55671e-08 1.5C-2.93554e-08 0.671572 0.671574 -1.01972e-06 1.5 -9.83506e-07C2.32843 -9.83506e-07 3 0.671572 3 1.5L3 22.5C3 23.3284 2.32843 24 1.5 24C0.671573 24 8.87631e-07 23.3284 9.23842e-07 22.5L-6.55671e-08 1.5Z" fill="white"/>
                </svg>
              </div>
            </div>
          </div>
        </article>

        <footer>
          <div class="footer__content">
            <button pButton pRipple label="Tomar fotografía" icon="pi pi-camera" iconPos="left" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="captureImage(field.id)" [disabled]="disabled()"></button>
            <span class="form__msgValidate mr-2" *ngIf="cameraAccessDenied">
              <small class="p-validate">
                <i class="pi pi-spin pi-spinner"></i>
               <span>Por favor, activa el permiso de la  cámara.</span>
              </small>
             </span>
          </div>
        </footer>
      </div>
    </div>
  </div>
</ng-container>


<!-- FOTOGRAFÍA CAPTURADA -->
<ng-container *ngIf="step === Step.image">
  <div class="container section__photography h-full">
    <div class="wrapper">
      <div class="sectionContainer fadeinright animation-duration-200">
        <article>
          <div class="mainInfo">
            <h1>¡Foto tomada con éxito!</h1>
            <p>A continuación, podrás ver el resultado y decidir si conservarla o tomar una nueva.</p>
          </div>

          <div class="webcamImage pt-30" *ngIf="webcamImage">
            <div class="webcamImage__cont mb-15">
              <img [src]="webcamImage.imageAsDataUrl" alt="Imagen capturada">
            </div>

            <div class="generalDescription mb-15">
              <p>Si estás satisfecho haz click en el botón <strong>“Continuar”</strong>, de lo contrario, puedes intentarlo nuevamente</p>
            </div>

            <div class="generalButton">
              <button pButton pRipple label="Reintentar" icon="pi pi-angle-left" iconPos="left" class="p-button-secondary p-button-raised p-button-rounded n-background min-pad" (click)="onGoToStep(Step.camera)"></button>
            </div>
          </div>
        </article>

        <footer>
          <div class="footer__content">
            <button pButton pRipple label="Continuar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="savePhoto()" [loading]="isLoading"></button>
          </div>
        </footer>
      </div>
    </div>
  </div>
</ng-container>
